import { createFileRoute } from '@tanstack/react-router';

import { creditNoteDetailSearch, loadCreditNoteMessages, loadCreditNoteDetailScreen } from '@/modules/credit-note/route';
import { lazyScreen } from '@/shared/screen';

// Mesmo caminho do legado (`/ccb/operacoes/:id`); a aba vai em `?tab=` (U42).
export const Route = createFileRoute('/_app/ccb/operacoes/$creditNoteId')({
  validateSearch: creditNoteDetailSearch,
  loader: () => loadCreditNoteMessages(),
  component: lazyScreen(loadCreditNoteDetailScreen, 'CreditNoteDetailScreen'),
});
